import { IHUBSERVICE_TOKEN } from '../../common/src/signalR/signalRServices';
import { InaxScriptService } from './script';



export const SCRIPT_HUBSERVICEPROVIDER_ENTRY = { provide: IHUBSERVICE_TOKEN, useClass: InaxScriptService, multi: true };